import { Call, RemoteParticipant } from "@azure/communication-calling";
import { toFlatCommunicationIdentifier } from "@azure/communication-react";

export const findParticipantInCallById = (call: Call | undefined, participantId: string): RemoteParticipant | undefined => {
    const participant = call?.remoteParticipants.find((p) => toFlatCommunicationIdentifier(p.identifier) === participantId);

    return participant;
}
